'use client';

import { MyBridgeThemeProvider } from '@mybridge/ui/theme-provider';
import { Provider } from 'react-redux';
import {
  SearchContextProvider,
  useSearchContext,
} from 'v4/snippets/search/context';
import { store } from '../../store/store';
import { useEffect, useState } from 'react';

export const ThemeProviders = ({ children, ...props }) => {
  const [language, setLanguage] = useState('en');

  // useEffect(() => {
  //   const storedLang = localStorage.getItem('userLanguage') || 'en';
  //   setLanguage(storedLang);
  // }, []);

  // useEffect(() => {
  //   if (typeof window !== 'undefined') {
  //     document.documentElement.lang = language;
  //     document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  //     localStorage.setItem('userLanguage', language);
  //   }
  // }, [language]);

  return (
    <>
      <Provider store={store}>
        {/* <SearchContext.Provider value={searchContext}> */}
        <SearchContextProvider>
          <MyBridgeThemeProvider {...props}>{children}</MyBridgeThemeProvider>
        </SearchContextProvider>
        {/* </SearchContext.Provider> */}
      </Provider>
    </>
  );
};

